import React, { useEffect } from 'react';
import { fetchHospital } from '@redux/hospitals/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useFeature, usePageActions } from '@hooks';
import { fetchPathwaySnapshots, fetchPathways } from '@pathways/redux/pathways/actions';
import { selectPathway, selectPathwaySnapshots } from '@pathways/redux/pathways/reducers';
import PathwayTitle from './PathwayTitle';
import PathwayDetailsBody from './PathwayDetailsBody';
import {
  CopyPathway,
  ShareSnapshot,
  EditPathway,
  PublishPathway,
  DeletePathway,
  CreateSnapshot,
} from './PathwayDetailsActions';
import useIsPrimaryOrganisation from '@hooks/useIsPrimaryOrganisation';

function PathwayDetails({ match }) {
  const dispatch = useDispatch();

  const pathwayId = Number(match.params.id);

  useEffect(() => {
    dispatch(fetchHospital());
    dispatch(fetchPathways());
    dispatch(fetchPathwaySnapshots(pathwayId));
  }, [dispatch, pathwayId]);

  const { setActions, setTitle } = usePageActions({
    actions: [],
    showBack: true,
    title: '',
  });

  const [, pathway] = useSelector(state => selectPathway(state, pathwayId));

  const snapshots = useSelector(selectPathwaySnapshots(pathwayId));
  const currentSharedSnapshot = snapshots.find(snap => snap.isSharedSnapshot);

  const isPrimaryOrganisation = useIsPrimaryOrganisation();
  const { pathwayLibrary: pathwayLibraryEnabled } = useFeature('pathwayLibrary');
  const pathwayDeleteEnabled =
    !pathway.isManagedPathway || isPrimaryOrganisation || pathwayLibraryEnabled;

  useEffect(() => {
    setTitle(<PathwayTitle pathway={pathway} snapshots={snapshots} />);

    if (pathway) {
      setActions([
        <ShareSnapshot parentPathwayId={pathwayId} pathway={pathway} disabled />,
        <CreateSnapshot
          pathway={pathway}
          currentSharedSnapshot={currentSharedSnapshot}
          disabled={pathway.isReadOnly}
        />,
        <CopyPathway pathway={pathway} />,
        <PublishPathway pathway={pathway} disabled={pathway.isReadOnly} />,
        <DeletePathway pathway={pathway} disabled={!pathwayDeleteEnabled} />,
        <EditPathway disabled={pathway.isReadOnly} />,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathwayId, pathway?.id, currentSharedSnapshot, snapshots?.length]);

  return <PathwayDetailsBody pathway={pathway} />;
}

export default PathwayDetails;
